export const templates = [
    {
        name: "@system/mobile/pages/listview",
        loader: () => import("./ListView"),
        pure: true,
    },
    {
        name: "@system/mobile/pages/user-profile",
        loader: () => import("./UserProfile"),
        pure: true,
    },
];